/**
 * External Imports
 */

import { FC } from 'react';
/**
 * Nexus Imports
 */
import { NeuTooltip } from '@neutron/react';
/**
 * Internal Imports
 */
import FilterBtn from '../filterBtn/FilterBtn';
/**
 * Global Type Definition Imports
 */
/**
 * Style Imports
 */
import {
  HelpIcon,
  HintSection,
  SummaryHeaderBar
} from './SummaryReportHeader.styles';
import { DateRangeSection } from '../customDateRangeSelect/CustomDateRangeSelect.styles';

interface SummaryReportHeaderProps {
  // filterValues: Filter;
  // setFilterValues: Dispatch<SetStateAction<Filter>>;
}

const SummaryReportHeader: FC<SummaryReportHeaderProps> = () => {
  return (
    <SummaryHeaderBar>
      <FilterBtn />
      <DateRangeSection>
        <HintSection className="ms-2">
          <NeuTooltip tip="Compliance, Issues, Feedback, and Stoplight metrics at a glance. The units/departments and date range selections can be changed using the filter button">
            <div style={{ width: '12em', marginTop: '1rem' }}>
              <HelpIcon size="1x" color="blue" fill={false} className="ms-1">
                help
              </HelpIcon>
              <span className="neu-text-blue-60 ms-1">
                What is this report?
              </span>
            </div>
          </NeuTooltip>
        </HintSection>
      </DateRangeSection>
    </SummaryHeaderBar>
  );
};
export default SummaryReportHeader;
